import React from 'react';
const TooltipDropdown = ({ content, open }) => {
    return (React.createElement("div", { className: "tooltip-dropdown-container" },
        React.createElement("div", { className: `tooltip-dropdown ${open ? 'tooltip-dropdown--open' : ''}` }, content)));
};
export default TooltipDropdown;
